import { Component, OnInit } from '@angular/core';
import { AddressesService } from '../services/addresses.service';
import { ShipmentsService } from '../services/shipments.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-advanced-bol',
  templateUrl: './advanced-bol.component.html',
  styleUrls: ['./advanced-bol.component.css']
})
export class AdvancedBolComponent implements OnInit {
  bolqtid;
  vwShipment;
  shipItems;
  shipItem;
  altaddresses;


  constructor(private addressesService: AddressesService,
              private shipmentsService: ShipmentsService, private router: Router) { }

  ngOnInit() {
  }

  onLoadBol() {
    // load bolqt data in component
    this.shipmentsService.getVwShipments(this.bolqtid)
    .then(shipment => {
      this.vwShipment = shipment[0];
      this.bolqtid = '';
      this.getShipItems(this.vwShipment.bolqtid)
      this.addressesService.getAltAddresses(this.vwShipment.clientid)
      .then(addresses => {
        this.altaddresses = addresses;
      })
    })
  }

  getShipItems(bolqtid) {
    this.shipmentsService.getShipItems(bolqtid)
    .then(shipItems => {
      this.shipItems = shipItems;
    })
    
  }

  onItemSelected(shipitemid) {
    if(shipitemid != 0) {
          // filter array to match bolqtid
        this.shipItem = this.shipItems.filter(function(item) {
          return item.shipitemid == shipitemid;
        });
        console.log(this.shipItem)
      }
    }
  onUpdateShipItem() {
      // update ship item selected
      console.log(this.shipItem[0])
      this.shipmentsService.onUpdateShipItem(this.shipItem[0])
      .then(response => {
        alert(JSON.stringify(response))
      })

    }

  onPickupSelected(id) {
    // update tblbolqt with change p/u location
    const type = "pickup";
    const bolqt = this.vwShipment.bolqtid;
    console.log(id)
    this.shipmentsService.changePuDelivId(bolqt, id, type)
    .then(result => {
          this.shipmentsService.getVwShipments(bolqt)
        .then(shipment => {
          this.vwShipment = shipment[0];
          alert(JSON.stringify(result))
        })
      }
    )
  }

  onDeliverySelected(id) {
    // update tblbolqt with change delivery location
    const type = "deliv";
    const bolqt = this.vwShipment.bolqtid;
    console.log(id)
    this.shipmentsService.changePuDelivId(bolqt, id, type)
    .then(result => {
      this.shipmentsService.getVwShipments(bolqt)
    .then(shipment => {
      this.vwShipment = shipment[0];
      alert(JSON.stringify(result))
      })
    })
  }

  onSetInactive() {
    const bolqt = this.vwShipment.bolqtid;
    const status = 0
    this.shipmentsService.setBolStatus(bolqt, status)
    .then(result => alert(JSON.stringify(result)))
  }

  onSetActive() {
    const bolqt = this.vwShipment.bolqtid;
    const status = 1
    this.shipmentsService.setBolStatus(bolqt, status)
    .then(result => alert(JSON.stringify(result)))
  }

  onNewAddress() {
    this.router.navigate(['/createaddress/' + this.vwShipment.clientid])
  }
}



// WEBPACK FOOTER //
// ./src/app/advanced-bol/advanced-bol.component.ts